define('modules/uv-shared-module/LoginWarningMessages',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LoginWarningMessages = /** @class */ (function () {
        function LoginWarningMessages() {
        }
        LoginWarningMessages.FORBIDDEN = "forbiddenResourceMessage";
        return LoginWarningMessages;
    }());
    exports.LoginWarningMessages = LoginWarningMessages;
});
//# sourceMappingURL=LoginWarningMessages.js.map
